export default {
  title: 'Your previous offer has been updated',
  introParagraph: 'We’ve updated your offer with the latest available terms.',
  additionalInfoParagraph:
    'If you wish to make changes, please speak to your Account Manager who can help.',
  button: 'Go to my updated offer'
};
